import React from 'react';
import { Link } from 'react-router-dom';
import { urlFacebook, urlInsta } from '../utils';
import Pdf from '../regulamin.pdf';
import { Vine1 } from './NatureDecorations';

const Footer = () => {
    return (
        <footer className="bg-niwy-primary text-white pt-16 pb-8 relative overflow-hidden" role="contentinfo">
            <Vine1 className="absolute top-0 right-0 h-full w-48 text-niwy-accent opacity-5 pointer-events-none" aria-hidden="true" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

                    {/* Brand Section */}
                    <div className="col-span-1 lg:col-span-1">
                        <h2 className="font-serif text-3xl mb-4 text-niwy-accent">Niwy Natury</h2>
                        <p className="text-gray-300 mb-6 text-sm leading-relaxed">
                            Pracownia Zdrowia. Miejsce, gdzie natura spotyka się z wiedzą, aby przywrócić harmonię Twojemu ciału i duszy.
                        </p>
                        <div className="flex space-x-4">
                            <a
                                href={urlFacebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-niwy-accent transition-colors"
                                aria-label="Odwiedź nasz profil na Facebooku"
                            >
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.791-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                            </a>
                            <a
                                href={urlInsta}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-niwy-accent transition-colors"
                                aria-label="Odwiedź nasz profil na Instagramie"
                            >
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div className="col-span-1">
                        <h3 className="text-niwy-accent font-serif text-xl mb-4">Kontakt</h3>
                        <ul className="text-gray-300 text-sm space-y-3">
                            <li className="flex items-start">
                                <span className="font-semibold w-16">Adres:</span>
                                <a href="https://maps.google.com/?q=ul.+Tuwima+14,+60-195+Poznań" target="_blank" rel="noopener noreferrer" className="hover:text-niwy-accent transition-colors">ul. Tuwima 14<br />60-195 Poznań</a>
                            </li>
                            <li className="flex items-center">
                                <span className="font-semibold w-16">Tel:</span>
                                <a href="tel:+48502622345" className="hover:text-niwy-accent transition-colors">502 622 345</a>
                            </li>
                            <li className="flex items-center">
                                <span className="font-semibold w-16">Email:</span>
                                <a href="mailto:kontakt@niwynatury.pl" className="hover:text-niwy-accent">kontakt@niwynatury.pl</a>
                            </li>
                        </ul>
                    </div>

                    {/* Quick Links */}
                    <div className="col-span-1">
                        <h3 className="text-niwy-accent font-serif text-xl mb-4">Nawigacja</h3>
                        <nav aria-label="Nawigacja stopki">
                            <ul className="text-gray-300 text-sm space-y-2">
                                <li><Link to="/" className="hover:text-niwy-accent transition-colors">Strona Główna</Link></li>
                                <li><Link to="/#about" className="hover:text-niwy-accent transition-colors">O nas</Link></li>
                                <li><Link to="/#services" className="hover:text-niwy-accent transition-colors">Usługi</Link></li>
                                <li><Link to="/kontakt" className="hover:text-niwy-accent transition-colors">Kontakt</Link></li>
                            </ul>
                        </nav>
                    </div>

                    {/* CTA or Motto */}
                    <div className="col-span-1">
                        <h3 className="text-niwy-accent font-serif text-xl mb-4">Godziny</h3>
                        <p className="text-gray-300 text-sm mb-4">
                            Pracujemy w elastycznych godzinach, aby dopasować się do Twoich potrzeb. Skontaktuj się z nami, aby ustalić termin.
                        </p>
                        <Link to="/kontakt" className="inline-block border border-niwy-accent text-niwy-accent px-4 py-2 rounded hover:bg-niwy-accent hover:text-niwy-primary transition-colors text-sm font-medium">
                            Zarezerwuj wizytę
                        </Link>
                    </div>

                </div>

                <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400">
                    <p>&copy; {new Date().getFullYear()} SolutionSpace. Wszelkie prawa zastrzeżone.</p>
                    <div className="mt-2 md:mt-0 flex space-x-4">
                        <a href={Pdf} target="_blank" rel="noopener noreferrer" className="hover:text-niwy-accent">Polityka Prywatności</a>
                        {/* Add other legal links here */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
